import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { urls } from "../configs/serviceConfig";
import { authorizationHeaders } from "./authorizationHeaders";
import { ProfileBuilderConfiguration } from "../types/ProfileBuilderConfig";

interface VerifyOtpRequest {
  email: string;
  otp: string;
}

export const referralApi = createApi({
  reducerPath: "referralApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${urls.referralService}`,
    prepareHeaders: authorizationHeaders,
  }),
  endpoints: (builder) => ({
    getProfileBuilderConfig: builder.query<ProfileBuilderConfiguration, string>(
      {
        query: (referringServiceId) => {
          return `/builder-config/${referringServiceId}}`;
        },
      }
    ),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetProfileBuilderConfigQuery } = referralApi;
